"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "subscribe", {
    enumerable: true,
    get: function() {
        return subscribe;
    }
});
const _ = require(".");
const subscribe = (args)=>{
    const { apiRoute, callback, depth, initialData, serverURL } = args;
    const onMessage = async (event)=>{
        const mergedData = await (0, _.handleMessage)({
            apiRoute,
            depth,
            event,
            initialData,
            serverURL
        });
        callback(mergedData);
    };
    if (typeof window !== 'undefined') {
        window.addEventListener('message', onMessage);
    }
    return onMessage;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zdWJzY3JpYmUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgaGFuZGxlTWVzc2FnZSB9IGZyb20gJy4nXG5cbmV4cG9ydCBjb25zdCBzdWJzY3JpYmUgPSA8VD4oYXJnczoge1xuICBhcGlSb3V0ZT86IHN0cmluZ1xuICBjYWxsYmFjazogKGRhdGE6IFQpID0+IHZvaWRcbiAgZGVwdGg/OiBudW1iZXJcbiAgaW5pdGlhbERhdGE6IFRcbiAgc2VydmVyVVJMOiBzdHJpbmdcbn0pOiAoKGV2ZW50OiBNZXNzYWdlRXZlbnQpID0+IHZvaWQpID0+IHtcbiAgY29uc3QgeyBhcGlSb3V0ZSwgY2FsbGJhY2ssIGRlcHRoLCBpbml0aWFsRGF0YSwgc2VydmVyVVJMIH0gPSBhcmdzXG5cbiAgY29uc3Qgb25NZXNzYWdlID0gYXN5bmMgKGV2ZW50OiBNZXNzYWdlRXZlbnQpID0+IHtcbiAgICBjb25zdCBtZXJnZWREYXRhID0gYXdhaXQgaGFuZGxlTWVzc2FnZTxUPih7IGFwaVJvdXRlLCBkZXB0aCwgZXZlbnQsIGluaXRpYWxEYXRhLCBzZXJ2ZXJVUkwgfSlcbiAgICBjYWxsYmFjayhtZXJnZWREYXRhKVxuICB9XG5cbiAgaWYgKHR5cGVvZiB3aW5kb3cgIT09ICd1bmRlZmluZWQnKSB7XG4gICAgd2luZG93LmFkZEV2ZW50TGlzdGVuZXIoJ21lc3NhZ2UnLCBvbk1lc3NhZ2UpXG4gIH1cblxuICByZXR1cm4gb25NZXNzYWdlXG59XG4iXSwibmFtZXMiOlsic3Vic2NyaWJlIiwiYXJncyIsImFwaVJvdXRlIiwiY2FsbGJhY2siLCJkZXB0aCIsImluaXRpYWxEYXRhIiwic2VydmVyVVJMIiwib25NZXNzYWdlIiwiZXZlbnQiLCJtZXJnZWREYXRhIiwiaGFuZGxlTWVzc2FnZSIsIndpbmRvdyIsImFkZEV2ZW50TGlzdGVuZXIiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7OztrQkFGaUI7QUFFdkIsTUFBTUEsWUFBWSxDQUFJQztJQU8zQixNQUFNLEVBQUVDLFFBQVEsRUFBRUMsUUFBUSxFQUFFQyxLQUFLLEVBQUVDLFdBQVcsRUFBRUMsU0FBUyxFQUFFLEdBQUdMO0lBRTlELE1BQU1NLFlBQVksT0FBT0M7UUFDdkIsTUFBTUMsYUFBYSxNQUFNQyxJQUFBQSxlQUFhLEVBQUk7WUFBRVI7WUFBVUU7WUFBT0k7WUFBT0g7WUFBYUM7UUFBVTtRQUMzRkgsU0FBU007SUFDWDtJQUVBLElBQUksT0FBT0UsV0FBVyxhQUFhO1FBQ2pDQSxPQUFPQyxnQkFBZ0IsQ0FBQyxXQUFXTDtJQUNyQztJQUVBLE9BQU9BO0FBQ1QifQ==